/**
 * @deprecated Import from 'src/integrations/nextjs/index.js' instead.
 * This file is kept for backwards compatibility.
 */
export { run as runNextjsInstallerAgent, config as NEXTJS_AGENT_CONFIG } from '../integrations/nextjs/index.js';
